import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type Campaign } from 'entities/Campaign'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { CampaignRoutes } from 'pages/campaigns/types'

export const duplicateCampaign = (campaign: Campaign, entities: IEntitiesStore): ActionItem => {
  return {
    icon: 'copy',
    text: 'Duplicate',
    onAction: () => {
      entities.eventLogStore.logEvent(
        'Campaign_Used',
        {
          event_id: 'campaign_used',
          action: 'Duplicated',
          agencyId: entities.organizationStore.agency_id,
        },
        { groupId: entities.organizationStore.id }
      )
      uiStore.changeRoute({
        path: `/${CampaignRoutes.root}/${CampaignRoutes.clone}/${campaign.id}`,
      })
    },
  }
}
